import { render, staticRenderFns } from "./QueryItem.vue?vue&type=template&id=1d2277b4&scoped=true&"
import script from "./QueryItem.vue?vue&type=script&lang=ts&"
export * from "./QueryItem.vue?vue&type=script&lang=ts&"
import style0 from "./QueryItem.vue?vue&type=style&index=0&id=1d2277b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2277b4",
  null
  
)

export default component.exports